import { MobileViewContainer } from "@core/components/layout/mobile-view-container";
import { CresoTextLogo } from "@core/components/logo/creso-logo";
import { SelfDeclarationForm } from "@core/components/self-declaration-form";
import { createFileRoute } from "@tanstack/react-router";
import { getDistributorByHandleOptions } from "creso-core/hooks";

export const Route = createFileRoute(
  "/(auth)/(headless)/mfd/declaration/$handle"
)({
  component: RouteComponent,
  loader: async ({ params, context }) => {
    const { queryClient } = context;
    const { handle } = params;
    const response = await queryClient.fetchQuery(
      getDistributorByHandleOptions({ handle })
    );
    return response;
  },
});

function RouteComponent() {
  const info = Route.useLoaderData();

  return (
    <MobileViewContainer>
      <div className="px-6 pt-10 flex flex-1 flex-col gap-8">
        <CresoTextLogo />
        <SelfDeclarationForm
          defaultStep={info.declaration_submitted ? "success" : "intro"}
          details={{
            name: info.name,
            arnCode: info.arn_code,
            phoneNumber: info.phone_number,
            email: info.email,
          }}
          otpVariant="sheet-on-mobile"
        />
      </div>
    </MobileViewContainer>
  );
}
